<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto">
      <h2 class="mb-4">
        {{ titleFaq }}
      </h2>
      <div>
        <VcMarkdownRender v-if="textFaq" :src="textFaq" />
      </div>
      <div class="faq-items mt-8">
        <template v-for="(item, index) in faqItems" :key="index">
          <div class="mb-2.5 rounded border-2 border-[#EDEDED] p-4 drop-shadow-[1px_2px_4px_rgba(0,0,0,0.05)]">
            <div class="flex cursor-pointer items-center justify-between font-bold" @click="toggleAccordion(index)">
              {{ item.label }}
              <VcIcon
                class="ml-1 text-[--color-primary]"
                :name="isOpen.includes(index) ? 'chevron-up' : 'chevron-down'"
                size="xs"
              />
            </div>
            <transition name="slide-fade-top">
              <div v-if="isOpen.includes(index)" class="pt-4">
                <VcMarkdownRender :src="item.text" />
              </div>
            </transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

type FaqItemsType = {
  label: string;
  text: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  titleFaq?: string;
  textFaq?: string;
  faqItems?: Array<FaqItemsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    "px-5 py-10 md:px-12 lg:py-14",
  ];
});

const isOpen = ref<number[]>([]);

function toggleAccordion(index: number) {
  if (isOpen.value.includes(index)) {
    isOpen.value = isOpen.value.filter((i: number) => i !== index);
    return;
  }

  isOpen.value.push(index);
}
</script>
